import type { ReactNode } from 'react'
import { ContentContainer } from '../content-container'
import { SkeletonFormActions } from './skeleton-form-actions'
import { SkeletonInputGroup } from './skeleton-input-group'

interface FieldGroupConfig {
  fields: number
  fieldClassName?: string
}

interface SkeletonFormPageProps {
  header: ReactNode
  fieldGroups: FieldGroupConfig[]
  showActions?: boolean
  sidebar?: ReactNode
  wrapper?: (children: ReactNode) => ReactNode
}

export const SkeletonFormPage = ({
  header,
  fieldGroups,
  showActions = true,
  sidebar,
  wrapper,
}: SkeletonFormPageProps) => {
  const body = (
    <>
      <div className="flex h-full w-full gap-5">
        <div className="flex w-full flex-col">
          <ContentContainer>
            {fieldGroups.map((group, i) => (
              <SkeletonInputGroup
                key={i}
                fields={group.fields}
                fieldClassName={group.fieldClassName}
              />
            ))}
          </ContentContainer>
        </div>
        {sidebar}
      </div>
      {showActions && <SkeletonFormActions />}
    </>
  )

  return (
    <>
      {header}
      {wrapper ? wrapper(body) : body}
    </>
  )
}
